window.VegasLocation = {
	modal: 'modal-location',
	tab_choice: '[data-location="choice"]',
	tab_new: '[data-location="new"]',
	address_cnt: 0,
	delivery_types: {
		"1": 'Доставка курьером',
		"2": 'Самовывоз'
	},

	/**
	 *  Открываем модалку и инициализируем ее содержимое
	 **/
	init: function ($btn_open_modal) {
		VegasLocation.modal = $btn_open_modal.attr('href').replace('#', '');

		let modal = document.getElementById(VegasLocation.modal),
			addresses = modal.querySelectorAll(VegasLocation.tab_choice + ' [data-address]');

		VegasLocation.address_cnt = addresses.length;

		if (addresses.length) {
			VegasLocation.toggle(VegasLocation.tab_choice);
		} else {
			VegasLocation.toggle(VegasLocation.tab_new);
		}

		let $modal_close = $('#' + VegasLocation.modal).find('.modal-close-block');
		if ($modal_close.length) {
			let cross = '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 224.512 224.512" style="enable-background:new 0 0 224.512 224.512;" xml:space="preserve"><g><polygon style="fill:#010002;" points="224.507,6.997 217.521,0 112.256,105.258 6.998,0 0.005,6.997 105.263,112.254 0.005,217.512 6.998,224.512 112.256,119.24 217.521,224.512 224.507,217.512 119.249,112.254 "/></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>';
			$modal_close.html('<button type="button" class="modal-close white" data-bs-dismiss="modal" aria-label="Close">' + cross + '</button>');
		}

		let $modal = new bootstrap.Modal(modal);
		$modal.show();
	},

	/**
	 * Выбираем адрес из списка доступных локаций
	 **/
	choice: function ($self) {
		let $container = $self.closest('.list-location');
		let $modal = $self.closest('#modal-location');

		$container.find('.active').removeClass('active');
		$self.addClass('active');

		$modal.find('[data-toggle=select-location]').removeAttr('disabled');
	},

	/**
	 * Выбираем и сохраняем адрес, который выбрал пользователь, затем закрываем модалку
	 **/
	select: function (address, delivery, callback) {
		let $modal = $('#' + VegasLocation.modal);
		let params;

		if (address.id) {
			params = {
				id: address.id,
				_token: App.csrf,
			}
		} else {
			params = {
				address: address.address,
				city_id: address.city_id || 0,
				store_id: address.store_id || 0,
				delivery: delivery,
				_token: App.csrf,
			};
		}

		$.post('/user_locations/set', params, function (data) {
			if (data.error) {
				// todo
				alert('Неправильное что то');
			} else {
				if (typeof callback === 'function')
					callback(data);

				$modal.trigger('changed', [{
					city_id: address.city_id || 0,
					address: address,
					delivery: delivery,
					location_id: address.id || data.id,
				}]);

				let $formCart = $("#form-cart");
				if ($formCart.length) {
					VegasCatalog.Cart.updateTotalAll({products_totals: true});
				}

				VegasLocation.reset();
				$('#location-address').text(address.address);
				$modal.modal('hide');

				if (data.reload) {
					if ($formCart.length) {
						VegasCatalog.popup('Проверьте цены на товары - они могли измениться.');
						VGLocationCity.setTitle(data.city);
					} else {
						location.reload();
					}
				}
			}
		});
	},

	/**
	 * Добавляем новый адрес
	 **/
	add: function (data) {
		let $address_list = $('#' + VegasLocation.modal).find('.list-location');

		if (data.view) {
			$address_list.append(data.view);
		}
	},

	/**
	 * Удаляем адрес, если не осталось доступных локаций, перекидываем пользователя на вкладку добавления адреса
	 **/
	remove: function ($self) {
		let $modal = $('#' + VegasLocation.modal);

		let params = {
			id: $self.data('id'),
			_token: App.csrf,
		};

		$.post('/user_locations/delete', params, function () {

		});

		$self.closest('li').remove();
		let $address = $modal.find('.list-location li');

		if (!$address.length) {
			VegasLocation.address_cnt = 0;
			VegasLocation.toggle(VegasLocation.tab_new);
		}
	},

	/**
	 * Переключаемся между вкладками
	 **/
	toggle: function (tab) {
		let $modal = $('#' + VegasLocation.modal);
		$modal.find('.location-area').hide();

		if (tab === VegasLocation.tab_new) {
			VgMap.choiceInMap();

			if (VegasLocation.address_cnt === 0) {
				$(tab).find('[data-toggle-location="choice"]').hide();
			} else {
				$(tab).find('[data-toggle-location="choice"]').show();
			}
		}

		$modal.find('.location-area' + tab).show();
	},

	/**
	 * Скидываем всё, что можно после закрытия модалки
	 */
	reset: function () {
		let $modal = $('#' + VegasLocation.modal);

		let clear = function () {
			$modal.find('#mapFoundLocation ymaps').remove();
			$modal.find('.list-location').find('.active').removeClass('active');
			$modal.find('input').val('');
			$modal.find('[data-toggle=select-location]').attr('disabled', 'disabled');
		};

		$modal.on('hide.bs.modal', function () {
			clear();
		});

		clear();
	}
};

/**
 * Listeners
 */
$(document).on('click', '[data-toggle="getModalLocation"]', function () {
	VegasLocation.init($(this));

	return false;
});

$(document).on('click', '[data-toggle="choice-location"]', function () {
	VegasLocation.choice($(this).closest('li'));

	return false;
});

$(document).on('click', '[data-toggle="select-location"]', function () {
	let $modal = $('#' + VegasLocation.modal),
		$activeAddress = $modal.find('.list-location > li.active'),
		id = $activeAddress.data('id'),
		address = $activeAddress.data('address'),
		delivery = $activeAddress.data('delivery-type')
	;

	VegasLocation.select({
		address: address,
		id: id
	}, delivery);

	return false;
});

$(document).on('click', '[data-toggle="add-location"]', function () {
	let $modal = $('#' + VegasLocation.modal),
		delivery_type = $modal.find('.newAddress.active').data('delivery-type')
	;

	if (delivery_type === 1) {
		let flat = '/' + $modal.find("#location-map-flat").val() || '';

		let address = {
			city_id: $modal.find("#location-map-city").val(),
			address: $modal.find("#location-map-street-hidden").val() + flat,
			fullAddress: $modal.find("#location-map-full-address").val() + flat,
		}

		if (!address.address) {
			$input.addClass('is-invalid');
		} else {
			VegasLocation.select(address, delivery_type, function (data) {
				VegasLocation.add(data);
			});
		}

	} else if (delivery_type === 2) {
		let $select = $modal.find('#address-stores .selectAddress'),
			store_id = parseInt($select.val()),
			store_address = $select.find('option[value="' + store_id + '"]').text()
		;

		if (!store_id) {
			$select.addClass('is-invalid');
		} else {
			VegasLocation.select({
				address: store_address,
				store_id: store_id
			}, delivery_type, function (data) {
				VegasLocation.add(data);
			});
		}
	}

	return false;
});

$(document).on('click', '[data-toggle="remove-location"]', function () {
	VegasLocation.remove($(this).closest('li'));

	return false;
});

$(document).on('click', '[data-toggle-location]', function () {
	let tab = $(this).data('toggle-location');

	if (tab === 'new') {
		VegasLocation.toggle(VegasLocation.tab_new);
	} else if (tab === 'choice') {
		VegasLocation.toggle(VegasLocation.tab_choice);
	}

	return false;
});

$(document).on('focus', `#${VegasLocation.modal} .is-invalid`, function () {
	$(this).removeClass('is-invalid');
});